import { render, staticRenderFns } from "./OutOfStockItems.vue?vue&type=template&id=2aebd3c4&"
import script from "./OutOfStockItems.vue?vue&type=script&lang=js&"
export * from "./OutOfStockItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports